import { Alert, Checkbox, message } from 'antd';
import { Button } from 'common/ui/button';
import { useState } from 'react';

// The backup codes, shown only once right after 2FA is turned on. The user
// must confirm they saved them before moving on.
export default function BackupCodes({
  codes,
  onDone,
  doneLabel = 'Hoàn tất',
}: {
  codes: string[];
  onDone: () => void;
  doneLabel?: string;
}) {
  const [saved, setSaved] = useState(false);
  const text = codes.join('\n');

  const copyAll = () => {
    navigator.clipboard.writeText(text);
    message.success('Đã sao chép mã dự phòng');
  };

  const download = () => {
    const blob = new Blob(
      [`Mã dự phòng xác thực hai lớp - Stag Admin\n\n${text}\n`],
      { type: 'text/plain;charset=utf-8' }
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'stag-admin-backup-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4">
      <Alert
        type="warning"
        showIcon
        message="Lưu lại các mã dự phòng"
        description="Mỗi mã chỉ dùng được một lần để đăng nhập khi bạn không có ứng dụng xác thực. Các mã này sẽ không được hiển thị lại."
      />
      <div className="grid grid-cols-2 gap-2 rounded bg-gray-50 p-4 font-mono text-sm">
        {codes.map(code => (
          <div key={code} className="text-center">
            {code}
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <Button type="button" variant="outline" className="flex-1" onClick={copyAll}>
          Sao chép tất cả
        </Button>
        <Button type="button" variant="outline" className="flex-1" onClick={download}>
          Tải xuống (.txt)
        </Button>
      </div>
      <Checkbox checked={saved} onChange={e => setSaved(e.target.checked)}>
        Tôi đã lưu các mã dự phòng ở nơi an toàn
      </Checkbox>
      <Button type="button" className="w-full" disabled={!saved} onClick={onDone}>
        {doneLabel}
      </Button>
    </div>
  );
}
